/**
 * Classe responsável por realizar a autenticação por biometria.
 * 
 * @type {LoginBiometria}
 */
class LoginBiometria {

    /**
     * Método construtor da classe.
     * 
     * @return {LoginBiometria}
     */
    constructor() {
        this.buttonStartDevice = document.getElementById('submit_entrar_usando_biometria');

        if (this.buttonStartDevice !== null) {
            this.buttonStartDevice.addEventListener('click', this.openDevice.bind(this));

            this.webSocket = new WebSocket("wss://127.0.0.1:9443/");

            this.webSocket.onopen = (data) => {

            };

            this.webSocket.onmessage = async (evt) => {
                try {
                    $.blockUI({message: '<h2>Digital capturada, realizando a autenticação.</h2>'});

                    headers = new Headers();
                    headers.append('X-Requested-With', 'XMLHttpRequest');
                    headers.append('Content-Type', 'application/json');
                    headers.append('Accept', 'application/json');

                    let resultAuth = await fetch(`/padrao/authusuariosysbiometria/api`, {
                        method: 'POST',
                        body: JSON.stringify({
                            digital: evt.data
                        }),
                        headers,
                        credentials: 'same-origin'
                    });

                    let dataAuth = await resultAuth.json();

                    if (dataAuth.success === false) {
                        alert(dataAuth.message);
                        $.unblockUI();
                        return;
                    }

                    window.location = '/home/index/';
                } catch (e) {
                    alert('Erro ao validar a biometria, tente novamente.');
                }

                $.unblockUI();
            };

            this.webSocket.onclose = (evt) => {
                this.showCloseOrErroMessage();
            };

            this.webSocket.onerror = (erro) => {
                this.showCloseOrErroMessage();
            };
        }
    }

    /**
     * Método responsável por indicar que ouve erro ou a conexão foi fechada(websocket).
     * 
     * @return {void}
     */
    showCloseOrErroMessage() {
        this.buttonStartDevice.disabled = true;
        this.buttonStartDevice.classList.add('btn-disabled');

        if (document.getElementsByClassName('msg-error-login-biometria').length === 0) {
            let msgErro = `<p><strong>Falha ao efetuar a comunicação com o leitor biométrico.</strong></p>
                                       <p>Possíveis problemas:</p>
                                       <p>- O leitor não está conectado.</p>
                                       <p>- O leitor enão stá instalado corretamente.</p>
                                       <p>- O cliente de biometria não está rodando`;

            this.buttonStartDevice.insertAdjacentHTML('afterend', `<div style="margin-top: 7rem !important;" class="msg-error msg-error-login-biometria"><p>${msgErro}</p></div>`);
        }
    }

    /**
     * Método responsável por iniciar a comunicação com o leitor biométrico.
     * 
     * @return {void}
     */
    async openDevice() {
        $.blockUI({message: `<div class="mt20 mb20 ml20 mr20">
                                            <img width="200" height="200" src="/images/biometria.png" />
                                            <h3>Coloque seu dedo no leitor biométrico.</h3>
                                         </div>`});

        this.webSocket.send(1);
    }
}

document.addEventListener("DOMContentLoaded", () => new LoginBiometria());